module.exports = __webpack_public_path__ + "static/media/splash.3cae9f78.jpg";